module.exports = __webpack_public_path__ + "static/media/user2.68f10497.svg";